export const DEFAULT_THEME_PALETTE_ID = "vissera-gold";

export const THEME_PALETTES = [
  {
    id: "vissera-gold",
    label: "Vissera Gold",
    description: "Warm gold and charcoal for the default premium brand look.",
    theme: {
      bg_primary: "#FDFBF7",
      bg_secondary: "#F5F2EB",
      bg_dark: "#1A1A1A",
      accent: "#B8860B",
      accent_hover: "#DAA520",
      accent_soft: "#C9A961",
      text_primary: "#111111",
      text_secondary: "#4B4B4B",
      text_muted: "#6B6B6B",
      border_light: "#E5E0D8",
      button_text: "#FFFFFF",
      interactive_bg: "#1A1A1A",
      interactive_text: "#FFFFFF",
    },
  },
  {
    id: "obsidian-red",
    label: "Obsidian Red",
    description: "A high-contrast black and red palette for bold presentation.",
    theme: {
      bg_primary: "#0F0F11",
      bg_secondary: "#18181C",
      bg_dark: "#050506",
      accent: "#C1121F",
      accent_hover: "#E5383B",
      accent_soft: "#8B1E24",
      text_primary: "#F8F8F8",
      text_secondary: "#D5D5D8",
      text_muted: "#A7A7AD",
      border_light: "#313138",
      button_text: "#FFFFFF",
      interactive_bg: "#111214",
      interactive_text: "#FFFFFF",
    },
  },
  {
    id: "ocean-slate",
    label: "Ocean Slate",
    description: "Deep blue-greys with a fresh cyan accent for a modern interface.",
    theme: {
      bg_primary: "#F5FAFC",
      bg_secondary: "#E9F2F6",
      bg_dark: "#102A43",
      accent: "#127EA8",
      accent_hover: "#0EA5C6",
      accent_soft: "#7BC6D9",
      text_primary: "#102A43",
      text_secondary: "#34506A",
      text_muted: "#61758A",
      border_light: "#C9D7E1",
      button_text: "#FFFFFF",
      interactive_bg: "#102A43",
      interactive_text: "#FFFFFF",
    },
  },
  {
    id: "forest-emerald",
    label: "Forest Emerald",
    description: "Muted stone backgrounds with green accents for a calm premium feel.",
    theme: {
      bg_primary: "#F6F8F3",
      bg_secondary: "#EBEFE5",
      bg_dark: "#16302B",
      accent: "#2D6A4F",
      accent_hover: "#40916C",
      accent_soft: "#95D5B2",
      text_primary: "#16302B",
      text_secondary: "#35534B",
      text_muted: "#5A736B",
      border_light: "#D4DDD2",
      button_text: "#FFFFFF",
      interactive_bg: "#16302B",
      interactive_text: "#FFFFFF",
    },
  },
  {
    id: "royal-plum",
    label: "Royal Plum",
    description: "Soft ivory, plum and indigo accents for an editorial luxury mood.",
    theme: {
      bg_primary: "#FBF8FC",
      bg_secondary: "#F2EBF5",
      bg_dark: "#2E1F3F",
      accent: "#7C3AED",
      accent_hover: "#8B5CF6",
      accent_soft: "#C4B5FD",
      text_primary: "#271A34",
      text_secondary: "#4B3C5C",
      text_muted: "#746584",
      border_light: "#DFD2E7",
      button_text: "#FFFFFF",
      interactive_bg: "#2E1F3F",
      interactive_text: "#FFFFFF",
    },
  },
];

export const THEME_PALETTE_MAP = Object.fromEntries(
  THEME_PALETTES.map((palette) => [palette.id, palette]),
);

export function hasThemePalette(id) {
  return Boolean(id && THEME_PALETTE_MAP[id]);
}

export function getThemePalette(id) {
  return THEME_PALETTE_MAP[id] || THEME_PALETTE_MAP[DEFAULT_THEME_PALETTE_ID];
}
